<i class="fa fa-times close_icon f-r fs-18 mr-15" [mat-dialog-close]="true"></i>
<div>
    <video [src]=sponsorInfo?.video alt="" width="700px" height="450px" autoplay controls controlsList="nodownload">
    </video>
</div>